var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-template",class:{ 'fade-in': _vm.fadeIn, 'fade-out': _vm.isFadingOut }},[(_vm.showSpinner)?_c('div',{staticClass:"spinner"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }